import { Popconfirm, Table } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../../App";
import { Fragment, useContext } from "react";
import { CommomPermission } from "../../common/Constants";
import moment from "moment";

export const IncompleteTable = ({ FlooringCases, DeleteFloorCases, pagePermission }) => {
  const navigate = useNavigate();
  const { authData, } = useContext(
    AuthenticationContext
  );
  const FlooringPErmission = authData?.permissions?.filter((it) => it.name === "flooring")?.map((itx) => itx?.submodules).flat()?.filter((its) => its?.name === "flooring-application");
  const FloorPagePErmission = FlooringPErmission !== undefined && FlooringPErmission?.length > 0 ? FlooringPErmission[0] : CommomPermission;
  const columns = [
    {
      title: "Application ID",
      dataIndex: "application_uniqueId",
      key: "application_uniqueId",
      width: 150,
    },
    {
      title: "Date & Time",
      dataIndex: "created_at",
      key: "created_at",
      width: 120,
      render: (text, record) => {
        return (
          <Fragment>
            <div className="text-[#1B252F] text-[13px]">
              {moment(record.created_at).format("DD-MM-YYYY HH:MM")}
            </div>
          </Fragment>
        );
      },
    },
    {
      title: "Flooring Type",
      dataIndex: "flooring_product",
      key: "flooring_product",
      width: 140,
      render: (flooringType) => (
        <div className="table-info-block">
          <span>
            {flooringType === "BODYONLY" ? "BODY ONLY" : flooringType}
          </span>
        </div>
      ),
    },
    {
      title: "Veh/Chassis No",
      dataIndex: "vehicle_reg_no",
      key: "vehicle_reg_no",
      width: 150,
      render: (vehChassisNo, item) => (
        <div className="ven-block">
          <h2>{`${item?.vehicle_reg_no !== null ? item?.vehicle_reg_no : "--"
            }`}</h2>
          <p>{`${item?.chassis_no !== null ? item?.chassis_no : "--"}`}</p>
        </div>
      ),
    },
    {
      title: "Make/Model",
      dataIndex: "make_model",
      key: "make_model",
      width: 200,
      render: (makeModel) => (
        <div className="make-model-block">
          <h2>{`${makeModel !== null ? makeModel : "--"}`}</h2>
        </div>
      ),
    },
    {
      title: "Intended Floor Amt",
      dataIndex: "intended_floor_amount",
      key: "intended_floor_amount",
      width: 140,
      render: (intendedFloorAmt) => (
        <div>
          <span>
            ${intendedFloorAmt !== null
              ? `${intendedFloorAmt.slice(0, intendedFloorAmt.indexOf("."))}`
              : "--"}{" "}
          </span>
        </div>
      ),
    },
    {
      title: "Case Exp",
      dataIndex: "expiry_date",
      key: "expiry_date",
      width: 100,
      render: (expiry_date) => (
        <div>
          <span>{expiry_date !== null ? `${expiry_date}` : "--"}</span>
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 140,
      render: (action, item) => (
        <div>
          {pagePermission?.update_permission == 1 && (
            <span
              className="view-resume-block"
              onClick={() => {
                navigate("/new-flooring-application", {
                  state: { appId: item?.id, ...FloorPagePErmission },
                });
              }}
            >
              <EyeOutlined className="mt-1" />
              <span>Resume</span>
            </span>
          )}


          <Popconfirm
            title="Delete Flooring Case"
            description="Are you sure to delete..?"
            onConfirm={() => {
              DeleteFloorCases(item?.id);
            }}
            onCancel={() => { }}
            okText="Yes"
            cancelText="No"
          >
            {pagePermission?.delete_permission == 1 && (
              <span
                className="table-delete-block"
                onClick={() => {
                  console.log("item", item);
                }}
              >
                <DeleteOutlined className="mt-1" />
                <span>Delete</span>
              </span>
            )}
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <Table
      dataSource={FlooringCases}
      columns={columns}
      scroll={{ x: "calc(400px + 50%)", y: 500 }}
    />
  );
};
